var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-sent-message",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}svg#freepik_stories-sent-message:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250.47px 363.75px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.47,
    cy: 363.75,
    rx: 209.77,
    ry: 121.11,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250.47px 363.75px"
    },
    id: "el7ghfykvv63g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "264.03px 390.94px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.1,
    cy: 377.74,
    rx: 49.24,
    ry: 28.43,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "217.1px 377.74px"
    },
    id: "elke2755i4cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.58,
    cy: 398.15,
    rx: 59.62,
    ry: 34.42,
    style: {
      fill: "#e0e0e0",
      transformOrigin: "300.58px 398.15px"
    },
    id: "elfbui0a2ck9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-2",
    className: "animable",
    style: {
      transformOrigin: "186.908px 245.15px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234 366.86c0-2.5-1.64-5-4.94-6.89-6.59-3.81-17.28-3.81-23.87 0-3.3 1.9-4.95 4.4-4.95 6.89v7.71c0 2.5 1.65 5 4.95 6.9 6.59 3.8 17.28 3.8 23.87 0 3.3-1.91 4.94-4.4 4.94-6.9v-7.71Z",
    style: {
      fill: "#263238",
      transformOrigin: "217.12px 370.716px"
    },
    id: "eld5qklnxbm9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1 367.68c6.59 3.81 6.59 10 0 13.79s-17.28 3.8-23.87 0-6.6-10 0-13.79 17.28-3.8 23.87 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "217.163px 374.575px"
    },
    id: "elqp0fg5mfhre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "217.16px 370.715px"
    },
    id: "elsiu6zqe61oj",
    className: "animable",
    d: "M200.28 366.86h33.76v7.71h-33.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.1 360c6.59 3.8 6.59 10 0 13.78s-17.28 3.81-23.87 0-6.6-10 0-13.78 17.28-3.84 23.87 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "217.163px 366.884px"
    },
    id: "el77xmt1h11hy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78 361.72c3.11 1.79 3.11 4.7 0 6.49a12.43 12.43 0 0 1-11.24 0c-3.1-1.79-3.1-4.7 0-6.49a12.43 12.43 0 0 1 11.24 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "217.164px 364.965px"
    },
    id: "elh7t8wezq03p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "217.16px 292.19px"
    },
    id: "elznfxdvhkfl",
    className: "animable",
    d: "M209.21 219.41h15.9v145.56h-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.09 152.19v-.11c-.15-.83-.33-1.67-.54-2.51a2.68 2.68 0 0 1 .07.27c-.13-.57-.28-1.14-.44-1.71.06.21.11.42.16.63-.16-.63-.34-1.25-.53-1.88.09.27.18.55.25.82-.1-.36-.21-.72-.32-1.08l-.18-.57v-.08.06a61.06 61.06 0 0 0-5.28-11.71c-.07-.13-.14-.26-.22-.39-5.45-9.27-13.35-17.74-22.17-23l-.43-.26a40 40 0 0 0-8-3.54 24.74 24.74 0 0 0-7.16-1.15h-1.35c-.42 0-.83.08-1.23.14h-.37l-.68.13c-.29.06-.58.13-.86.21l-.78.23h-.05l-.78.28c-.26.11-.52.22-.76.34l-1.72 1-86.61 50h-.07c-4.69 2.63-7.53 8-7.53 15.63v47.11l-32.59 18a20.81 20.81 0 0 0-.37 36.24 59.73 59.73 0 0 0 59.69 0l33.76-19 87.73-50.69v-47.12a35.37 35.37 0 0 0-.64-6.29Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "186.943px 194.63px"
    },
    id: "elmkyvyy9l75m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "170.98px 175.535px"
    },
    id: "elrvjimkybxm9",
    className: "animable",
    d: "M140.61 217.78v-52.63l55.72-31.86 5.02 48.66-60.74 35.83z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldw2iyxg13mp"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      transformOrigin: "170.98px 175.535px"
    },
    className: "animable",
    id: "ely7deg77spnq",
    d: "M140.61 217.78v-52.63l55.72-31.86 5.02 48.66-60.74 35.83z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "170.98px 213.775px"
    },
    id: "elba5c9pokf9",
    className: "animable",
    d: "m140.61 217.78 60.74-35.83v57.27l-12.56 6.38-48.18-27.82z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela837cat80s5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "170.98px 213.775px"
    },
    className: "animable",
    id: "eljx6f7w0d0f",
    d: "m140.61 217.78 60.74-35.83v57.27l-12.56 6.38-48.18-27.82z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m282.1 152.19-5.76 3.17-35.06 19.19-6.34 3.45-43.82 24c-2.78-4.7-10-26.63-13.85-30.6a58 58 0 0 0-12.58-10c-5.5-3.18-10.65-4.69-15.1-4.69a15.37 15.37 0 0 0-7.52 1.79l86.62-50 1.72-1c.24-.12.5-.23.76-.34l.78-.28h.05l.78-.23c.28-.08.57-.15.86-.21l.68-.13h.37c.4-.06.81-.11 1.23-.14h1.35a24.74 24.74 0 0 1 7.16 1.15 40 40 0 0 1 8 3.54l.43.26c14.49 8.45 26.51 25.76 29.24 41.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "212.085px 154.085px"
    },
    id: "el0olqziska1nb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 158.56h-.07Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "141.965px 158.56px"
    },
    id: "ele1v32lhr03q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu51vsgavbnb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "212.015px 154.085px"
    },
    className: "animable",
    id: "elju9y9nuzrh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m282.1 152.19-5.76 3.17-35.06 19.19-6.34 3.45-43.82 24c-2.78-4.7-10-26.63-13.85-30.6a58 58 0 0 0-12.58-10c-5.5-3.18-10.65-4.69-15.1-4.69a15.37 15.37 0 0 0-7.52 1.79l86.62-50 1.72-1c.24-.12.5-.23.76-.34l.78-.28h.05l.78-.23c.28-.08.57-.15.86-.21l.68-.13h.37c.4-.06.81-.11 1.23-.14h1.35a24.74 24.74 0 0 1 7.16 1.15 40 40 0 0 1 8 3.54l.43.26c14.49 8.45 26.51 25.76 29.24 41.07Z",
    id: "elv3xepn1p61d",
    className: "animable",
    style: {
      transformOrigin: "212.085px 154.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 158.56h-.07Z",
    id: "el0m1atm8vx9i",
    className: "animable",
    style: {
      transformOrigin: "141.965px 158.56px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M275 134c.08.12.16.25.23.38a.647.647 0 0 0-.23-.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "275.115px 134.19px"
    },
    id: "elq4jv3uddws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65 143.5a48.74 48.74 0 0 1 2.45 8.69l-5.76 3.17-35.06 19.19-6.34 3.45-43.82 24 3.88 54.29 87.73-50.69v-47.12a42.72 42.72 0 0 0-3.08-14.98Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.925px 199.895px"
    },
    id: "elc8a3cr3731",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.35 140.36c-.37-.82-.76-1.65-1.17-2.47.41.82.82 1.65 1.17 2.47Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "277.765px 139.125px"
    },
    id: "eljsu593lbz3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66 135c.42.76.84 1.52 1.23 2.29-.39-.73-.8-1.49-1.23-2.29Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "276.275px 136.145px"
    },
    id: "el7ggseto14ay",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62 143.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "279.065px 142.07px"
    },
    id: "elvi87lq69zvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkppsw1pvvaf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "236.925px 195.145px"
    },
    className: "animable",
    id: "elspivw46f4pn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275 134c.08.12.16.25.23.38a.647.647 0 0 0-.23-.38Z",
    id: "elzm5zafa30w",
    className: "animable",
    style: {
      transformOrigin: "275.115px 134.19px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65 143.5a48.74 48.74 0 0 1 2.45 8.69l-5.76 3.17-35.06 19.19-6.34 3.45-43.82 24 3.88 54.29 87.73-50.69v-47.12a42.72 42.72 0 0 0-3.08-14.98Z",
    id: "ellzlmalewpuk",
    className: "animable",
    style: {
      transformOrigin: "236.925px 199.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.35 140.36c-.37-.82-.76-1.65-1.17-2.47.41.82.82 1.65 1.17 2.47Z",
    id: "elwsr8ngw91uf",
    className: "animable",
    style: {
      transformOrigin: "277.765px 139.125px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66 135c.42.76.84 1.52 1.23 2.29-.39-.73-.8-1.49-1.23-2.29Z",
    id: "elpchfjzi7r6",
    className: "animable",
    style: {
      transformOrigin: "276.275px 136.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62 143.41Z",
    id: "elcgmmrzv30b7",
    className: "animable",
    style: {
      transformOrigin: "279.065px 142.07px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.59 162.93c3.49 0 7.65 1.33 12 3.86 14.73 8.5 27.18 27.91 27.18 42.39v36.42l-48.18-27.82v-43.55c0-9.34 4.88-11.3 9-11.3m0-6.18c-9.06 0-15.15 6.27-15.15 17.48v47.11l60.52 35v-47.16c0-16.72-13.55-38.09-30.26-47.74-5.5-3.17-10.67-4.69-15.11-4.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "164.7px 206.545px"
    },
    id: "elh4wth2cgmbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.44 221.34-32.59 18a20.81 20.81 0 0 0-.37 36.24 59.73 59.73 0 0 0 59.69 0L195 256.29Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "143.043px 252.455px"
    },
    id: "elzt0jd4k5cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2eiysnv1dnh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m134.44 221.34-32.59 18a20.81 20.81 0 0 0-.37 36.24 59.73 59.73 0 0 0 59.69 0L195 256.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "143.043px 252.455px"
    },
    className: "animable",
    id: "elvycg7wudku"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "211.75px 211.07px"
    },
    id: "eli9g8wg9w7u",
    className: "animable",
    d: "m215.15 241.94-6.8 3.92v-65.65l6.8-3.93v65.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "218.17px 181.095px"
    },
    id: "eltcwer1jaym",
    className: "animable",
    d: "m227.99 181.99-19.64 11.33v-13.11l19.64-11.34v13.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.08 239.63a14.1 14.1 0 0 1-6.38 11.05c-3.53 2-6.39.39-6.39-3.68a14.09 14.09 0 0 1 6.39-11c3.52-2.09 6.38-.44 6.38 3.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "211.695px 243.315px"
    },
    id: "elabzdctzorss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyhojoq1s2hf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.08 239.63a14.1 14.1 0 0 1-6.38 11.05c-3.53 2-6.39.39-6.39-3.68a14.09 14.09 0 0 1 6.39-11c3.52-2.09 6.38-.44 6.38 3.63Z",
    style: {
      opacity: 0.2,
      transformOrigin: "211.695px 243.315px"
    },
    className: "animable",
    id: "elhs9755nn1kr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.2 240.86a14.09 14.09 0 0 1-6.38 11c-3.52 2-6.38.38-6.38-3.69a14.13 14.13 0 0 1 6.38-11.05c3.53-1.98 6.38-.33 6.38 3.74Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "213.82px 244.499px"
    },
    id: "elfs69vj4wwv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    className: "animable",
    style: {
      transformOrigin: "380.892px 326.085px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m362.72 349 11.28 6.54s-5.7-18.19-2.54-36.48c1.19-6.9 3.71-10.33 4.59-12.18s7.7-13.25 1.7-18.51-20.05 5.2-19.42 33.38a109.63 109.63 0 0 0 4.39 27.25Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "369.252px 321.3px"
    },
    id: "elscowu1kdeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgqajr11u4m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m362.72 349 11.28 6.54s-5.7-18.19-2.54-36.48c1.19-6.9 3.71-10.33 4.59-12.18s7.7-13.25 1.7-18.51-20.05 5.2-19.42 33.38a109.63 109.63 0 0 0 4.39 27.25Z",
    style: {
      opacity: 0.3,
      transformOrigin: "369.252px 321.3px"
    },
    className: "animable",
    id: "el2xa2ebdsl9e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368 352.54a.52.52 0 0 1-.47-.33c0-.12-4.31-12-4.09-31s10.28-29.32 10.38-29.42a.5.5 0 1 1 .71.71c-.1.1-9.86 10-10.08 28.72s4 30.51 4 30.63a.5.5 0 0 1-.3.64.39.39 0 0 1-.15.05Z",
    style: {
      fill: "#fff",
      transformOrigin: "369.054px 322.091px"
    },
    id: "el9bgx5wbxx1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.47 354.11 18.65 11s8.54-1.26 7.9-9.3-4.12-9.94.2-13.47 5.44-3.76 5.23-7.23-2.53-5-3.63-6.34-4.15-4.25-2-8.43 5.06-8.21.74-10.12c-2.59-1.14-6.93.29-9.8 3.34s-5.26 5.26-8 6-8.41.76-8.22 5.46 1.41 6.32.27 8.4c-2.13 3.87-11.3 5.99-1.34 20.69Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "385.195px 337.47px"
    },
    id: "elt5819xzfc7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.07 359.08a.5.5 0 0 1-.5-.47c0-.28-2.06-28.08 17.26-46.34a.51.51 0 1 1 .7.73c-19 17.92-17 45.26-17 45.53a.51.51 0 0 1-.46.55Z",
    style: {
      fill: "#fff",
      transformOrigin: "387.622px 335.58px"
    },
    id: "el74pxlsd2f5y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.41 335.24a.5.5 0 0 1-.5-.46 15.88 15.88 0 0 0-5.67-11.1.5.5 0 1 1 .59-.81 16.58 16.58 0 0 1 6.09 11.83.5.5 0 0 1-.47.54Z",
    style: {
      fill: "#fff",
      transformOrigin: "379.478px 329.007px"
    },
    id: "elyuajn62pr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 340a.48.48 0 0 1-.34-.13.5.5 0 0 1 0-.71c.2-.23 5.06-5.48 16.3-3.94a.52.52 0 0 1 .44.57.51.51 0 0 1-.57.43c-10.72-1.47-15.37 3.56-15.42 3.61a.51.51 0 0 1-.41.17Z",
    style: {
      fill: "#fff",
      transformOrigin: "388.958px 337.469px"
    },
    id: "el68fatwf3a8o",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "101.201px 129.955px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn,1.5s Infinite linear shake",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.35 190.53c-.89 0-1.79 0-2.67-.11a.91.91 0 0 1-.84-1 .93.93 0 0 1 1-.84 26.65 26.65 0 0 0 3.57.09.94.94 0 0 1 .95.89.92.92 0 0 1-.88.95c-.39.02-.76.02-1.13.02Zm4.74-.38a.92.92 0 0 1-.15-1.83 26.53 26.53 0 0 0 3.47-.81.92.92 0 0 1 .53 1.76 28.07 28.07 0 0 1-3.7.87Zm-11-.26h-.18a34.57 34.57 0 0 1-3.66-1 .94.94 0 0 1-.59-1.17.93.93 0 0 1 1.17-.58 30.71 30.71 0 0 0 3.45.92.91.91 0 0 1 .71 1.09.92.92 0 0 1-.88.74Zm18-1.91a.92.92 0 0 1-.4-1.75l.64-.31a.92.92 0 1 1 .83 1.64l-.68.34a.91.91 0 0 1-.37.1Zm-25-.39a.92.92 0 0 1-.39-.09 34.41 34.41 0 0 1-3.33-1.78.92.92 0 1 1 1-1.57 33 33 0 0 0 3.16 1.68.93.93 0 0 1-.39 1.76Zm-6.3-3.8a1 1 0 0 1-.55-.18c-1-.74-2-1.55-2.9-2.41a.92.92 0 1 1 1.24-1.36c.9.82 1.83 1.59 2.77 2.3a.92.92 0 0 1-.56 1.65Zm-5.43-4.95a.91.91 0 0 1-.68-.3c-.83-.91-1.65-1.88-2.41-2.88a.92.92 0 0 1 1.46-1.12c.73 1 1.51 1.88 2.31 2.76a.92.92 0 0 1-.06 1.3.93.93 0 0 1-.57.24Zm-4.43-5.84a.9.9 0 0 1-.77-.43c-.4-.62-.79-1.26-1.16-1.9-.25-.44-.5-.89-.74-1.34a.92.92 0 0 1 1.62-.86 42.596 42.596 0 0 0 1.83 3.11.93.93 0 0 1-.78 1.42Zm-3.44-6.5a.92.92 0 0 1-.85-.56c-.49-1.16-.93-2.35-1.31-3.53a.92.92 0 0 1 .59-1.16.93.93 0 0 1 1.16.6c.36 1.13.78 2.26 1.25 3.37a.91.91 0 0 1-.84 1.28Zm-2.24-7a.93.93 0 0 1-.9-.73 34.84 34.84 0 0 1-.6-3.73.92.92 0 0 1 .82-1 .86.86 0 0 1 .39 0 .89.89 0 0 1 .67-.46 22 22 0 0 0 3.44-.76.92.92 0 0 1 .55 1.76 24.68 24.68 0 0 1-3.74.83.88.88 0 0 1-.23 0c.12 1 .29 2 .5 2.94a.91.91 0 0 1-.71 1.09.63.63 0 0 1-.19.07Zm-3.17-3.82a28.75 28.75 0 0 1-3.79-.31.92.92 0 0 1 .27-1.82 25.21 25.21 0 0 0 3.54.29.92.92 0 0 1 0 1.84Zm-7.26-1.08a.73.73 0 0 1-.25 0 29.33 29.33 0 0 1-3.57-1.3.92.92 0 0 1 .73-1.69 26.82 26.82 0 0 0 3.36 1.19.93.93 0 0 1 .63 1.14.94.94 0 0 1-.9.67Zm17.93-1.33a.92.92 0 0 1-.42-1.73 15.2 15.2 0 0 0 2.88-1.92.93.93 0 0 1 1.3.09.92.92 0 0 1-.1 1.3 16.1 16.1 0 0 1-3.23 2.16.94.94 0 0 1-.43.11Zm-8.25-1.08a.93.93 0 0 1-.91-.94 31.26 31.26 0 0 1 .29-3.78.92.92 0 1 1 1.82.26 29.49 29.49 0 0 0-.27 3.55.93.93 0 0 1-.93.92Zm-16.44-.47a1 1 0 0 1-.46-.12 32.07 32.07 0 0 1-3.16-2.1.9.9 0 0 1-.18-1.28.92.92 0 0 1 1.29-.19 28.3 28.3 0 0 0 3 2 .92.92 0 0 1-.46 1.72Zm30.12-3.28a.93.93 0 0 1-.46-.12.92.92 0 0 1-.33-1.26 8.72 8.72 0 0 0 .66-1.43 6 6 0 0 0 .34-1.64.91.91 0 0 1 1-.85.92.92 0 0 1 .85 1 8.24 8.24 0 0 1-.44 2.12 10.59 10.59 0 0 1-.8 1.74.93.93 0 0 1-.82.45Zm-36-1.14a.93.93 0 0 1-.64-.26l-.61-.62c-.67-.69-1.32-1.42-1.94-2.18a.92.92 0 1 1 1.43-1.16c.58.72 1.2 1.41 1.83 2.06l.57.58a.91.91 0 0 1 0 1.3.94.94 0 0 1-.62.29Zm23.36-2.38a.84.84 0 0 1-.27 0 .92.92 0 0 1-.61-1.15 14.82 14.82 0 0 1 1.59-3.57.92.92 0 1 1 1.56 1 12.91 12.91 0 0 0-1.39 3.13.91.91 0 0 1-.86.6Zm-28-3.32a.91.91 0 0 1-.77-.42 37 37 0 0 1-1.89-3.26.92.92 0 0 1 1.64-.84 34.76 34.76 0 0 0 1.79 3.1.92.92 0 0 1-.77 1.42Zm41.17-.23a.92.92 0 0 1-.85-.57 5.33 5.33 0 0 0-1.91-2.43.92.92 0 0 1 1-1.53 7.16 7.16 0 0 1 2.58 3.26.91.91 0 0 1-.49 1.2.92.92 0 0 1-.31.08Zm-9.17-2.46a.93.93 0 0 1-.76-.4.92.92 0 0 1 .24-1.28 8.15 8.15 0 0 1 3.86-1.41.92.92 0 1 1 .16 1.83 6.26 6.26 0 0 0-3 1.11 1 1 0 0 1-.48.16Zm-35.37-3.84a.92.92 0 0 1-.85-.58c-.46-1.15-.88-2.34-1.24-3.55a.92.92 0 1 1 1.76-.53c.35 1.15.75 2.3 1.19 3.4a.93.93 0 0 1-.52 1.19.8.8 0 0 1-.32.08Zm-2.13-7a.92.92 0 0 1-.9-.73 49.23 49.23 0 0 1-.64-3.7.92.92 0 0 1 1.82-.24c.16 1.2.37 2.39.62 3.56a.92.92 0 0 1-.71 1.09Zm-1-7.29a.93.93 0 0 1-.92-.87c0-1-.08-2-.08-3v-.77a.94.94 0 0 1 .94-.9.9.9 0 0 1 .9.93v.74c0 1 0 1.92.08 2.87a.93.93 0 0 1-.86 1Z",
    style: {
      fill: "#263238",
      transformOrigin: "128.871px 152.885px"
    },
    id: "el1gl7mv7l02p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "64.48px 99.25px"
    },
    id: "elhiiw4kfejto",
    className: "animable",
    d: "m97.26 87.3-5.5 23.9L31.7 98.31 97.26 87.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq9kobypzvcg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "64.48px 99.25px"
    },
    className: "animable",
    id: "el5muk5u05zub",
    d: "m97.26 87.3-5.5 23.9L31.7 98.31 97.26 87.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.7 98.31 74.78-2 17.57 27.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "77.875px 109.85px"
    },
    id: "elcvmpmizqbno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "64.48px 83.845px"
    },
    id: "elfwhlxpis14a",
    className: "animable",
    d: "M31.7 98.31 97.26 87.3 81.81 69.38 31.7 98.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    className: "animable",
    style: {
      transformOrigin: "262.29px 246.485px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elbaqqudefnzc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "172.295px 168.09px"
    },
    className: "animable",
    id: "elorvnzuoqvhq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.33 168.09h-.07Z",
    id: "el0u2ol7zixtnc",
    className: "animable",
    style: {
      transformOrigin: "172.295px 168.09px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el37fygtwoije"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945959",
      transformOrigin: "283.855px 363.165px",
      transform: "rotate(1.46deg)"
    },
    className: "animable",
    id: "elg9o8vo0ery9",
    d: "M275.94 347.14h15.83v32.05h-15.83z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.38 218.7s-1.11 54.52-.73 76.12c.29 16.27 2.83 65 2.83 65s10.26 6.7 21.07 1.1c0 0 6.24-49.22 4.72-64.05a25.09 25.09 0 0 1 0-5.41l9.54-82.54Z",
    style: {
      fill: "#37474f",
      transformOrigin: "289.69px 286.036px"
    },
    id: "el1uh8nbz8k02",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 374.55s8.77-1 10.54-3.86v-1.86s1.52.81 1.23 3.89c-.26 2.86.88 7.73 1.05 13.67a3.1 3.1 0 0 1-1.2 2.52c-1.7 1.31-5.29 3.32-11.62 3.59-2.22.1-11.1 5.79-18.49 5.79s-12.22-3.66-12.22-8.78 15.07-9.75 15.07-9.75l7.24-7s-1.41-7.63 3.2-5.8 5.2 3.73 5.2 7.59Z",
    style: {
      fill: "#37474f",
      transformOrigin: "272.055px 382.483px"
    },
    id: "elmxex2qoau2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 379a.46.46 0 0 1-.44-.32c-1.54-4.61-6.35-5.46-6.4-5.47a.46.46 0 0 1-.38-.53.47.47 0 0 1 .53-.38 9.51 9.51 0 0 1 7.12 6.09.46.46 0 0 1-.29.58Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "276.013px 375.648px"
    },
    id: "elb2l2lk8lyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51 381.86a.48.48 0 0 1-.44-.32c-1.53-4.59-6.35-5.46-6.4-5.47a.45.45 0 0 1-.37-.53.46.46 0 0 1 .53-.38 9.51 9.51 0 0 1 7.12 6.09.46.46 0 0 1-.3.58.32.32 0 0 1-.14.03Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "273.132px 378.507px"
    },
    id: "elbpbot788dsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 384.34a.45.45 0 0 1-.43-.31c-1.53-4.6-6.35-5.47-6.4-5.48a.46.46 0 1 1 .15-.9 9.48 9.48 0 0 1 7.12 6.09.46.46 0 0 1-.29.58Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "270.595px 380.985px"
    },
    id: "el3t8z0y2tp3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33 389.51c0 5.06 4.73 8.69 12 8.77l10.35-4.15c0-10.73-7.26-14.37-7.26-14.37s-15.09 4.64-15.09 9.75Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "261.505px 389.02px"
    },
    id: "elagzpgm5acp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6 386.83c-1.77 1.37-5.53 3.48-12.15 3.77-2.33.1-11.61 6-19.34 6-5.3 0-9.34-1.8-11.36-4.67 1.31 3.79 5.67 6.31 11.8 6.31 7.39 0 16.27-5.69 18.49-5.79 6.33-.27 9.92-2.28 11.62-3.59a3.07 3.07 0 0 0 1.18-2.3 2.5 2.5 0 0 1-.24.27Z",
    style: {
      fill: "#263238",
      transformOrigin: "272.295px 392.4px"
    },
    id: "elcwzvpgjymym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55 226.33s1.45 12.34 10.91 18.86l8.35 41.87 5.36-52.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "292.86px 256.695px"
    },
    id: "el36yp9227pgq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzyw54d2mzi"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945959",
      transformOrigin: "328.265px 372.725px",
      transform: "rotate(-4.47deg)"
    },
    className: "animable",
    id: "elzt7gpvkcwqc",
    d: "M320.35 356.7h15.83v32.05h-15.83z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.83 220s1.91 7.23 2.83 37.06c.74 23.64 1.29 37.24 1.49 41.86a26.44 26.44 0 0 0 .37 3.43 337.21 337.21 0 0 1 3.9 36c1.35 23 1.46 33.89 1.46 33.89s-9.76 7.63-21.54 1.64l-11.4-68.54-12-63.61s-16.45-6.27-17.9-23Z",
    style: {
      fill: "#37474f",
      transformOrigin: "307.46px 297.452px"
    },
    id: "elvwe7umeefq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.83 380.76.25 3.12s-1.88 2.64-4.1 3.41c0 0-1.7-6.21-4.71-6.53s-9.26-.6-8.42 2.86a28.68 28.68 0 0 1 .87 5.51l-5.8 10.81s-11.77 10.14-6.85 16.6 21.43 3 23.06-7.14a11.26 11.26 0 0 1 4.94-7.53 6.26 6.26 0 0 0 2.81-6.47c-.3-2.32-1-6.78-.79-8.79s.77-5.82-1.26-5.85Z",
    style: {
      fill: "#37474f",
      transformOrigin: "322.929px 400.199px"
    },
    id: "eljx69fctz4dg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07 416.54c4.09 5.37 16.15 3.9 21.07-2.56a15.61 15.61 0 0 0 .32-3.19c0-11.55-14.54-10.85-14.54-10.85s-11.77 10.14-6.85 16.6Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "318.164px 409.878px"
    },
    id: "elarfb4zn0046",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88 395.4c0-.17-.05-.37-.08-.57a6.18 6.18 0 0 1-2.91 4.52 11.64 11.64 0 0 0-5.1 7.79c-1.66 10.38-18.36 14-23.66 7.59a5.8 5.8 0 0 0 .94 1.81c4.92 6.47 21.43 3 23.06-7.14a11.26 11.26 0 0 1 4.94-7.53 6.26 6.26 0 0 0 2.81-6.47Z",
    style: {
      fill: "#263238",
      transformOrigin: "323.061px 407.326px"
    },
    id: "elwx9eypgwwlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.27 391.54a.47.47 0 0 1-.32-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46 0 1 1-.29-.87 9.47 9.47 0 0 1 9.15 2 .45.45 0 0 1 0 .65.47.47 0 0 1-.31.14Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "324.899px 389.931px"
    },
    id: "elodit3x1hci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.25 395.55a.47.47 0 0 1-.31-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46 0 0 1-.29-.88 9.52 9.52 0 0 1 9.15 2 .47.47 0 0 1 0 .65.48.48 0 0 1-.32.15Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "322.902px 393.939px"
    },
    id: "elfuytucf475i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.24 399.56a.47.47 0 0 1-.31-.12c-3.52-3.33-8.18-1.82-8.23-1.8a.46.46 0 0 1-.29-.88 9.49 9.49 0 0 1 9.15 2 .47.47 0 0 1 0 .65.49.49 0 0 1-.32.15Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "320.892px 397.947px"
    },
    id: "ellgpqcprz98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06 90.6a89 89 0 0 1-2-12.26c-.24-4.83-1.64-6.52-4.59-4.1s-9.67 9.44-9.27 14.91a34.32 34.32 0 0 0 5.59 17l8.6 2.6 3.44-7.06Z",
    style: {
      fill: "#945959",
      transformOrigin: "217.006px 90.9476px"
    },
    id: "ell1eomffwhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.34 134.32-17.23-3.81s-7.34-11.89-11.59-18.16-6.66-10.61-6.66-10.61l-8-2.43-4.08 6.89s13.41 33.33 19.63 39c3.13 2.82 23.35 9.08 23.35 9.08s8.49-8.96 4.58-19.96Z",
    style: {
      fill: "#945959",
      transformOrigin: "238.075px 126.795px"
    },
    id: "elfhe91eaygm8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.06 139-21.72-4.68a56.72 56.72 0 0 1-4.54 19.92l21.82 6.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.93px 147.66px"
    },
    id: "elso25mn8gz1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1smren9xhug"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m283.06 139-21.72-4.68a56.72 56.72 0 0 1-4.54 19.92l21.82 6.76Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "269.93px 147.66px"
    },
    className: "animable",
    id: "elh27fe67eyid"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m313.19 141.61 10.1 3.18 5.54 29.88-3.28 14.49a16.52 16.52 0 0 0-.25 6l3.53 24.84s-10 6.38-28.39 6.38-29.06-7.63-29.06-7.63l1.39-56.38A36.66 36.66 0 0 1 283.06 139l12.53 1.45Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "300.105px 182.69px"
    },
    id: "elhpzqpt226wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35 94.18s-9.65 8.47-1.26 27.35L289.9 96Z",
    style: {
      fill: "#263238",
      transformOrigin: "283.281px 107.855px"
    },
    id: "el2efj0m7cl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945959",
      transformOrigin: "304.39px 131.59px"
    },
    id: "elgy978vapr1",
    className: "animable",
    d: "m313.19 141.61-12.16 3.91-5.44-5.07v-22.79h17.6v23.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59 139c5.94 0 15-5.29 15-9l2-12.37h-17Z",
    style: {
      fill: "#703838",
      transformOrigin: "304.09px 128.315px"
    },
    id: "elhefy3qcnlgt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27 89c-5.92 0-18.51 3.3-20 18.79s.82 28.68 7.95 28.68c14 0 27.46-1.78 27.57-24.7.12-20.27-9.74-22.77-15.52-22.77Z",
    style: {
      fill: "#945959",
      transformOrigin: "297.815px 112.735px"
    },
    id: "elltzim8ynz0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.19 125.3-2.28-7a1.18 1.18 0 0 1-1.94-.89v-12.5s-5.82-1.65-5.2-6.55c0 0-3 2.67-14.41 2.67S275.16 91.34 276.3 86c0 0 2.12 2.19 8.16 2.19s31.19-7.59 31.84 7.6c0 0 2.12-3.11 5.55 0l-4.41 2.62s5.23-.16 4.41 7.51c-.53 5-2.38 13.89-3.58 19.34a12.1 12.1 0 0 1-5.08 7.45Z",
    style: {
      fill: "#263238",
      transformOrigin: "299.001px 109.355px"
    },
    id: "eljcdneduuxt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#703838",
      transformOrigin: "288.695px 117.375px"
    },
    id: "elsq0ctd9bli",
    className: "animable",
    d: "M291.61 112.4v9.95l-5.83-1.79 5.83-8.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87 114a1.86 1.86 0 1 1-1.86-1.87 1.86 1.86 0 0 1 1.86 1.87Z",
    style: {
      fill: "#263238",
      transformOrigin: "299.01px 113.99px"
    },
    id: "el02qt2dk73yec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94 112.68a1.86 1.86 0 1 1-1.86-1.86 1.86 1.86 0 0 1 1.86 1.86Z",
    style: {
      fill: "#263238",
      transformOrigin: "285.08px 112.68px"
    },
    id: "elhzl9caqctio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.81 108.8 3.64-2.16s-1.4-1.45-2.79-.58-.85 2.74-.85 2.74Z",
    style: {
      fill: "#263238",
      transformOrigin: "284.578px 107.291px"
    },
    id: "el3bgyil3crg2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.8 110.15-3.65-2.15s1.4-1.45 2.79-.58.86 2.73.86 2.73Z",
    style: {
      fill: "#263238",
      transformOrigin: "301.025px 108.646px"
    },
    id: "elyy2zhlgy07o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.08 127.13s2.7-1.73 5.3-3.68c0 0 1.51 2.94-.87 4.46s-4.43-.78-4.43-.78Z",
    style: {
      fill: "#703838",
      transformOrigin: "294.966px 125.94px"
    },
    id: "elhqaoj2jrzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#253239",
      transformOrigin: "313.97px 113.52px"
    },
    id: "el1virlunp4k6",
    className: "animable",
    d: "m310.75 118.4 6.44-6.98-4.63-2.78-1.81 9.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81 115.68c-2.11 3.66-1.56 8.1 1.38 9.62 1.89 1 7.47-1.13 9.58-4.79s.93-6.79-1.94-8.44-6.91-.07-9.02 3.61Z",
    style: {
      fill: "#945959",
      transformOrigin: "317.191px 118.482px"
    },
    id: "elb9z3upp6ulh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.59 140.45-2.4 3.81a6.17 6.17 0 0 0 2.51 8.84 11.3 11.3 0 0 0 15.53-6.21l2-5.28-8.8-3.15Z",
    style: {
      fill: "#945959",
      transformOrigin: "302.733px 146.349px"
    },
    id: "elpop98vtts6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86 101.74s2.94-4.48 2.89-8.73.48-6.22 1.21-7.24-.09-2.51-2.05-2c-1.66.45-3.71 3-4.16 5.35a2.56 2.56 0 0 1-1.27 1.79c-2.07 1.11-5.93 4.29-4.1 12Z",
    style: {
      fill: "#945959",
      transformOrigin: "224.062px 93.2883px"
    },
    id: "el2dwgk2fd1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 97.66a.35.35 0 0 1-.29-.4 8.93 8.93 0 0 1 4.61-6.64 2.14 2.14 0 0 0 1.1-1.54.35.35 0 0 1 .41-.27.34.34 0 0 1 .27.4 2.85 2.85 0 0 1-1.45 2 8.24 8.24 0 0 0-4.26 6.14.34.34 0 0 1-.39.31Z",
    style: {
      fill: "#703838",
      transformOrigin: "220.906px 93.2336px"
    },
    id: "elh7q9ujxq68j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#945959",
      transformOrigin: "338.385px 186.085px"
    },
    id: "elbwptilodeqb",
    className: "animable",
    d: "m324.77 181.63 4.44 9.36 22.79 9.02-9.19-27.85-18.04 9.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94 144.37s-7.6 7.81-4.31 18.82a116.1 116.1 0 0 0 7.14 18.44s12.81.38 18-9.47l-6.53-16.48a17.88 17.88 0 0 0-12-10.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "329.787px 163.001px"
    },
    id: "elojmxxrlvc38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxir3cz8vgp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.94 144.37s-7.6 7.81-4.31 18.82a116.1 116.1 0 0 0 7.14 18.44s12.81.38 18-9.47l-6.53-16.48a17.88 17.88 0 0 0-12-10.67Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "329.787px 163.001px"
    },
    className: "animable",
    id: "elwjaywl1vwhh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.93 189.25c5.76 1.69 22.74 6.72 22.74 6.72s.13.37 1.33 4c1.84 5.65-4 19.32-24.68 9.4s-28.23-15.23-28.23-15.23l2.25-12.55s20.02 5.73 26.59 7.66Z",
    style: {
      fill: "#945959",
      transformOrigin: "325.705px 197.236px"
    },
    id: "el3l7ocedsj1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#703838",
      transformOrigin: "333.255px 189.735px"
    },
    id: "el83a7xt4fb6",
    className: "animable",
    d: "m328.54 189.54 10.71 3.09-11.99-5.79 1.28 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.14 199.81-13.44-1.43a2.38 2.38 0 0 1-2.06-1.76L275.3 169a1.24 1.24 0 0 1 1.26-1.56l13 .61a2.27 2.27 0 0 1 2.1 1.68l7.82 28.53a1.25 1.25 0 0 1-1.34 1.55Z",
    style: {
      fill: "#37474f",
      transformOrigin: "287.388px 183.628px"
    },
    id: "el1umbeyhrb2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55 171.49a1.16 1.16 0 1 1-1.15-1.16 1.16 1.16 0 0 1 1.15 1.16Z",
    style: {
      fill: "#263238",
      transformOrigin: "279.39px 171.49px"
    },
    id: "eltnxrm5arygl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.34 181.63s-3.89-6.76-8.72-8.4l1.93 7.43s-3.67.29-7.82.29-8.69-2.8-10-3.52-2.53 4.3 2.69 13.76 19.71 3 19.71 3Z",
    style: {
      fill: "#945959",
      transformOrigin: "288.467px 184.786px"
    },
    id: "eli7tr43khzl",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2",
    className: "animable",
    style: {
      transformOrigin: "390.145px 78.2246px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m360.06 45.63 7.24 4.12v-3.68c.26-3.4 2.83-4.7 6-2.89a11.72 11.72 0 0 1 3.57 3.43c.71-4.61 4.47-6.28 9-3.65C390.91 45.87 395 53 395 58.8v5.49a2.52 2.52 0 0 0 1.24 2.15l4.25 2.49a6.15 6.15 0 0 1 3 5.3 2.54 2.54 0 0 1-3.8 2.19l-39.52-22.86a6.91 6.91 0 0 1-3.45-6 2.24 2.24 0 0 1 3.34-1.93Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "380.105px 59.2331px"
    },
    id: "elqze13c9l5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.44 91.68 5.35 3v-2.64c.19-2.51 2.09-3.47 4.41-2.13a8.55 8.55 0 0 1 2.64 2.53c.52-3.41 3.3-4.64 6.67-2.7a15 15 0 0 1 6.76 11.72v4.06a1.85 1.85 0 0 0 .91 1.59l3.15 1.84a4.55 4.55 0 0 1 2.24 3.92 1.87 1.87 0 0 1-2.8 1.62l-29.25-16.95a5.1 5.1 0 0 1-2.52-4.42 1.65 1.65 0 0 1 2.44-1.44Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "406.285px 101.778px"
    },
    id: "el8nr3wg595gk",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRequest);
export default __webpack_public_path__ + "static/media/noRequest.09372545767bb25e5d2d83bb818bfc1c.svg";
export { ForwardRef as ReactComponent };